import { NessieThemeColors } from "@classdojo/web/nessie/components/theme";
import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";

export const TABLE_TOPICS = () => ({
  description: autoTranslate("Conversation starters to bring your family closer"),
  pageUrl: "/beyondToolkit/tableTopics",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/107.png",
  imgSrc: "/static/images/toolkit_table_topics.png",
  loggingId: "table_topics",
  unlocked: true,
  title: autoTranslate("Dinner topics"),
  color: "dt_content_accent" as NessieThemeColors,
});

export const TIMER = () => ({
  description: autoTranslate("Help your kids get ready on time or read longer with this countdown timer"),
  pageUrl: "/beyondToolkit/timer",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/42.png",
  imgSrc: "/static/images/toolkit_timer.png",
  loggingId: "timer",
  title: autoTranslate("Timer"),
  color: "dt_blueberry50",
  unlocked: true,
});

export const MINDFULNESS = () => ({
  description: autoTranslate("Relaxing meditations to put your child's mind at ease"),
  pageUrl: "/beyondToolkit/mindfulness",
  imgSrc: "/static/images/toolkit_mindfulness.png",
  loggingId: "mindfulness",
  unlocked: true,
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/55.png",
  title: autoTranslate("Bedtime meditations"),
  color: "#4e10eb" as NessieThemeColors,
});

export const BEDTIME_STORIES = () => ({
  title: autoTranslate("Bedtime stories"),
  description: autoTranslate("Short stories for you and your child to listen to before bed"),
  pageUrl: "/beyondToolkit/bedtimeStories",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/53.png",
  imgSrc: "/static/images/toolkit_bedtime.png",
  color: "dt_content_plus",
  loggingId: "bedtime",
  unlocked: true,
});

export const READ_ALONGS = () => ({
  title: autoTranslate("Read alongs"),
  description: autoTranslate("Educational storybooks that increase kids’ love for reading"),
  pageUrl: "/beyondToolkit/readAlongs",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/94.png",
  imgSrc: "https://dojoicons.classdojo.com/beyond_school/300/94.png",
  background: "linear-gradient(79.76deg, #1EF1A5 -28.69%, #3388D7 141.03%)",
  color: "#194BE0",
  loggingId: "read_alongs",
  unlocked: true,
});

export const MUSIC = () => ({
  description: autoTranslate("Dreamy tunes to help your child fall asleep faster"),
  pageUrl: "/beyondToolkit/music",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/86.png",
  imgSrc: "/static/images/toolkit_music.png",
  loggingId: "music",
  unlocked: true,
  title: autoTranslate("Sleep music"),
  color: "#194BE0",
});

export const WHOSE_TURN = () => ({
  description: autoTranslate("The fun way to remember whose turn it is or to choose who's next"),
  pageUrl: "/beyondToolkit/whoseTurn",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/137.png",
  loggingId: "whose_turn",
  unlocked: true,
  title: autoTranslate("Whose turn"),
  color: "dt_content_danger",
  imgSrc: "/static/images/toolkit_whose_turn.png",
});

export const BRUSH_TEETH = () => ({
  description: autoTranslate("Two minutes of brushing music"),
  pageUrl: "/beyondToolkit/brushTeeth",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/88.png",
  loggingId: "brush_teeth",
  unlocked: true,
  title: autoTranslate("Brush your teeth!"),
  background: "linear-gradient(171.67deg, #75B4FF 5.98%, #DD519E 93.98%)",
  duration: 119,
  mainAudio: "/static/media/activity-brushteeth_song.mp3",
});

export const SHAKE_SILLIES = () => ({
  description: autoTranslate("Dance it all away before bed"),
  pageUrl: "/beyondToolkit/shakeSillies",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/119.png",
  loggingId: "shake_sillies",
  unlocked: true,
  title: autoTranslate("Get the wiggles out!"),
  color: "rgb(84,223,207)" as NessieThemeColors,
  background: "linear-gradient(177.77deg, #FFCB69 8.36%, #EF4EAF 146.44%)",
  duration: 177,
  mainAudio: "/static/media/activity-wiggleit_song.mp3",
});
